/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  PaidPhone component
 */

/** @jsx jsx */
import { Box, Link as ChakraLink, useColorModeValue } from '@chakra-ui/react'
import { jsx } from '@emotion/react'
import { Phone } from '@zcode-ui/icons'
import { toTelHref } from '@zcode/nr/es/shared/utils/utils'
import type { SyntheticEvent } from 'react'

export interface Props {
  paidPhone: string
  onClick: (e: SyntheticEvent) => void
}

export const PaidPhone = ({ paidPhone, onClick }: Props) => {
  const textColor = useColorModeValue('gray.600', 'gray.300')
  const iconColor = useColorModeValue('#726F6C', '#CECBC8')
  const phoneHref = toTelHref(paidPhone)
  return (
    <ChakraLink<'a'> alignItems="center" display="inline-flex" href={phoneHref} onClick={onClick}>
      <Phone fill={iconColor} stroke={iconColor} />
      <Box<'div'>
        color={textColor}
        fontSize="sm"
        letterSpacing="-0.2px"
        ml={2}
        mt={1}
        textDecor="underline"
      >
        {paidPhone}
      </Box>
    </ChakraLink>
  )
}
